import styled from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

export const Container = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 74px;
  z-index: 10000;
  box-sizing: border-box;
  background: ${theme.colors.primary.black};
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.03);
  font-size: 17px;
  line-height: 22px;
  color: ${theme.colors.primary.white};

  display: flex;
  flex-direction: row;

  span {
    align-self: center;
    font-size: 17px;
    line-height: 22px;
    font-family: 'Clan Pro';
    font-weight: ${theme.weights.bold};
  }
`;

export const ActionArrow = styled.div`
  display: flex;
  flex-direction: row;
  align-self: center;
  justify-content: center;
  cursor: pointer;
  width: 45px;
  margin: 0px 10px;
`;

export const NoArrow = styled.div`
  display: flex;
  flex-direction: row;
  align-self: center;
  justify-content: center;
  cursor: pointer;
  width: 35px;
`;
